import React from 'react';
import type { NavLinkProps } from 'react-router-dom';
import { NavLink } from 'react-router-dom';

export const ReactRouterMUINavLink = React.forwardRef<
  HTMLAnchorElement,
  Omit<NavLinkProps, 'to'> & { href: NavLinkProps['to'] }
>((props, ref) => {
  const { href, ...other } = props;
  return <NavLink ref={ref} to={href} {...other} />;
});
